import Vue from 'vue';
import Router from 'vue-router';

import Scan from '@/views/Scan.vue';
import Queue from '@/views/Queue.vue';
import Login from '@/views/Login.vue';
import Response from '@/views/Response.vue';

Vue.use(Router);

const baseRoutes: any = [
  {
    path: '/scan',
    name: 'scan',
    component: Scan,
  },
  {
    path: '/queue',
    name: 'queue',
    component: Queue,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/response/:qrCode',
    name: 'response',
    component: Response,
    props: true,
  },
  {
    path: '*',
    redirect: '/login',
  },
];

const router = new Router({
  mode: 'history',
  routes: baseRoutes,
});

export default router;
